module.exports = __webpack_public_path__ + "static/media/monitoringAlert.96bcaa0c.svg";